import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { getLiteral } from 'utils/getLiteral';
import Select from 'components/Select';
import { ButtonBulkOutline } from 'components/buttons';
import UsersMappingLine from 'containers/settings/deprecatedIntegrationsManagement/components/UsersMappingLine';
import { ErrorAlert } from 'components/alerts';
import './style.scss';

class UsersMapping extends PureComponent {
    state = {
        fmUser: undefined,
        extUser: undefined,
    };

    constructor(props) {
        super(props);
    }

    handleFmUserChange = (newValue) => {
        this.setState({ fmUser: newValue });
    };

    handleExtUserChange = (newValue) => {
        this.setState({ extUser: newValue });
    };

    handleAddUser = () => {
        this.props.onAddUser(this.state.fmUser, this.state.extUser);
        this.setState({
            fmUser: null,
            extUser: null,
        });
    };

    renderLines() {
        let lines = [];
        let { usersConfig, fmUsers, extUsers, onDeleteUser } = this.props;
        if (usersConfig.lenght !== 0) {
            usersConfig.map((userConfig, index) => {
                lines.push(
                    <UsersMappingLine
                        key={index}
                        index={index}
                        userConfig={userConfig}
                        fmUsers={fmUsers.obj}
                        extUsers={extUsers.obj}
                        onDeleteUser={onDeleteUser}
                    />,
                );
            });
        }
        return <div className="users-mapping-selected-lines">{lines}</div>;
    }

    renderAlertError() {
        let { stepperAlertErrors } = this.props;
        if (!stepperAlertErrors.errors) return null;
        return (
            <div className="users-mapping-alert users-mapping-error">
                <ErrorAlert text={stepperAlertErrors.text} shrink={true} />
            </div>
        );
    }

    render() {
        let { fmUsers, extUsers, literals } = this.props;
        let addButtonDisabled = this.state.fmUser && this.state.extUser ? false : true;
        return (
            <div className="users-mapping">
                <div className="users-mapping-title-description">
                    <div className="users-mapping-title">
                        <Literal
                            literal={
                                literals['label_integration_match_users'] ||
                                'label_integration_match_users'
                            }
                        />
                    </div>
                    <div className="users-mapping-description">
                        <Literal
                            literal={
                                literals['label_integration_user_matching_description'] ||
                                'label_integration_user_matching_description'
                            }
                        />
                    </div>
                </div>
                {this.renderAlertError()}
                <div className="users-mapping-selectors">
                    <div className="users-mapping-selectors-header">
                        <Literal
                            literal={
                                literals['label_integration_fm_users'] ||
                                'label_integration_fm_users'
                            }
                        />
                        <Literal
                            literal={
                                literals['label_integration_sl_users'] ||
                                'label_integration_sl_users'
                            }
                        />
                    </div>
                    <div className="users-mapping-selectors-add">
                        <div className="fm-user-select-container">
                            <Select
                                className="fm-user-select"
                                value={this.state.fmUser}
                                options={fmUsers.arr}
                                onChange={this.handleFmUserChange}
                                placeholder={getLiteral(
                                    literals['label_integration_select_user'] ||
                                        'label_integration_select_user',
                                )}
                            />
                        </div>
                        <div className="fm-user-select-container">
                            <Select
                                className="ext-user-select"
                                value={this.state.extUser}
                                options={extUsers.arr}
                                onChange={this.handleExtUserChange}
                                placeholder={getLiteral(
                                    literals['label_integration_select_user'] ||
                                        'label_integration_select_user',
                                )}
                            />
                        </div>
                        <div className="add-user-btn-container">
                            <ButtonBulkOutline
                                classes={['add-user-btn']}
                                onClick={this.handleAddUser}
                                disabled={addButtonDisabled}
                            >
                                <Literal
                                    literal={
                                        literals['label_integration_add_user'] ||
                                        'label_integration_add_user'
                                    }
                                />
                            </ButtonBulkOutline>
                        </div>
                    </div>
                </div>
                <div className="users-mapping-selected">
                    <div className="users-mapping-selected-header">
                        <Literal
                            literal={
                                literals['label_integration_users_matched'] ||
                                'label_integration_users_matched'
                            }
                        />
                    </div>
                    {this.renderLines()}
                </div>
            </div>
        );
    }
}

export default UsersMapping;
